import React from 'react';
import { BodyText, Link, ContextualAlert, CaptionText, AddCameraIcon, TextDisplay, HeadingText } from '@paypalcorp/pp-react';
import { get } from 'lodash';
import { show, hide } from '../../common/domUtils';
import withTheme from '../../common/withTheme';

class LogoImage extends React.Component {
    constructor(props) {
        super(props);
    }

    onFileChange = () => {
        //Validate File Type
        const file = document.getElementById('fileupload').value;
        const validExtns = ['jpg', 'jpeg', 'png', 'gif'];
        const fileInfoSplit = file.split('.');
        if (!validExtns.includes(fileInfoSplit[fileInfoSplit.length - 1])) {
            document.getElementById('fileupload').value = '';
            this.props.updateFileError(get(this.props.propertyInfo, 'directmodel.enroll.uploadlogo.typeerror'));
            this.props.updateFileInfo('');
            return false
        }
        //Validate File Size
        const file_size = document.getElementById('fileupload').files[0].size;
        if (file_size > 512000) {
            document.getElementById('fileupload').value = '';
            this.props.updateFileInfo('');
            this.props.updateFileError(get(this.props.propertyInfo, 'directmodel.enroll.uploadlogo.sizeerror'));
            return false;
        }

        const input = document.getElementById('fileupload');
        if (input.files && input.files[0]) {
            hide('.fileUpload');
            this.props.updateFileError('');
            this.props.updateFileInfo(URL.createObjectURL(input.files[0]));
        }
    }

    onClickRemoveImg = () => {
        show('.fileUpload');
        this.props.updateFileInfo('');
    }

    onClickChangeImg = () => {
        document.getElementById('fileupload').click();
    }

    render() {
        return (
            <React.Fragment>
                <HeadingText size='sm'>{get(this.props.propertyInfo, 'directmodel.enroll.uploadlogo.title')}</HeadingText>
                <TextDisplay value={get(this.props.propertyInfo, 'directmodel.enroll.uploadlogo.note')} />
                <div className="upload">
                    <div className="plus-padding">
                        <div id="logoImage">
                            {this.props.fileUrl && <img id="uploadedLogo" src={this.props.fileUrl} alt="" />}
                            <div className="fileUpload" style={{ display: this.props.fileUrl ? 'none' : 'block' }}>
                                <label id="fileLabel" htmlFor="fileupload">
                                    <span><AddCameraIcon size="lg" /></span>
                                    <span>{get(this.props.propertyInfo, 'directmodel.enroll.uploadlogo.placeholder')}</span>
                                </label>
                                <input onChange={this.onFileChange} accept="image/gif, image/jpeg, image/png" type="file" id="fileupload" name="fileupload" />
                            </div>
                        </div>
                        {this.props.fileUrl && <div className="action">
                            <Link href="#" onClick={this.onClickRemoveImg}>{get(this.props.propertyInfo, 'directmodel.enroll.uploadlogo.remove')}</Link>
                            <Link href="#" onClick={this.onClickChangeImg}>{get(this.props.propertyInfo, 'directmodel.enroll.uploadlogo.replace')}</Link>
                        </div>}
                    </div>
                </div>
                {this.props.fileError && <ContextualAlert type="error">{this.props.fileError}</ContextualAlert>}
                <div style={{ marginTop: '15px' }}> <TextDisplay label=
                    {get(this.props.propertyInfo, 'directmodel.enroll.uploadlogo.bottomnote')} /></div>
            </React.Fragment>
        );
    }
}
export default withTheme(LogoImage);